module.exports = __webpack_public_path__ + "static/media/aboutUs.2a73b616.svg";